import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {}

const ThreadsRev: React.FC<SVGProps> = (props) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = props?.fill?.trim() ? props?.fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? "29"}
      height={height ?? "24"}
      viewBox="0 0 29 24"
      fill="none"
      style={{ color: finalColor }}
    >
      <path
        d="M13.8083 24H9.09567C9.08154 24 9.05892 24 9.03065 23.9986C7.39665 23.9777 5.86866 23.102 5.03682 21.7101L0.651445 14.3604C-0.217148 12.9042 -0.217148 11.0951 0.651445 9.63963L5.03682 2.2906C5.87997 0.877726 7.43552 0 9.09567 0H18.0028C19.663 0 21.2185 0.877725 22.0617 2.2899L23.0653 3.97139C23.3027 4.36979 23.1684 4.88331 22.7649 5.11774C22.3613 5.35287 21.8412 5.21961 21.6037 4.82121L20.6001 3.13972C20.0609 2.23548 19.0651 1.67382 18.0028 1.67382H9.09567C8.03343 1.67382 7.03762 2.23548 6.49837 3.13972L2.113 10.4887C1.55679 11.4202 1.55679 12.5784 2.113 13.5099L6.49837 20.8589C7.03267 21.7541 8.01717 22.315 9.0674 22.3234H9.11051L13.8083 22.3241C14.2768 22.3241 14.6564 22.6988 14.6564 23.1613C14.6564 23.6239 14.2768 23.9986 13.8083 23.9986V24Z"
        fill="currentColor"
      />
      <path
        d="M16.5257 23.9629C16.3752 23.9629 16.2253 23.9231 16.0932 23.8457C15.8769 23.7187 15.7285 23.5038 15.6882 23.2582L14.9263 18.5751C14.8952 18.3819 14.9334 18.1837 15.0344 18.0156L21.7019 6.91073C22.8051 5.07364 25.2159 4.46523 27.076 5.55437C27.9771 6.08184 28.6167 6.92398 28.8761 7.9259C29.1355 8.92782 28.9842 9.96951 28.4499 10.8598L21.7825 21.9646C21.6814 22.1328 21.5238 22.2612 21.3372 22.3267L16.8098 23.9147C16.7172 23.9468 16.6218 23.9629 16.5257 23.9629ZM16.6501 18.6086L17.202 22.0002L20.4807 20.8504L26.9919 10.0065C27.2951 9.50134 27.3813 8.91038 27.2336 8.34174C27.0859 7.7731 26.7234 7.29517 26.2117 6.99585C25.7 6.69653 25.1014 6.6121 24.5254 6.75723C23.9494 6.90235 23.4652 7.26098 23.1621 7.76612L16.6508 18.61L16.6501 18.6086Z"
        fill="currentColor"
      />
      <path
        d="M17.5569 8.87959H7.81294C7.34437 8.87959 6.96484 8.50492 6.96484 8.04234C6.96484 7.57975 7.34437 7.20508 7.81294 7.20508H17.5569C18.0255 7.20508 18.405 7.57975 18.405 8.04234C18.405 8.50492 18.0255 8.87959 17.5569 8.87959Z"
        fill="currentColor"
      />
      <path
        d="M15.2472 12.9773H7.81294C7.34437 12.9773 6.96484 12.6026 6.96484 12.14C6.96484 11.6774 7.34437 11.3027 7.81294 11.3027H15.2472C15.7158 11.3027 16.0953 11.6774 16.0953 12.14C16.0953 12.6026 15.7158 12.9773 15.2472 12.9773Z"
        fill="currentColor"
      />
      <path
        d="M12.7438 17.0739H7.89766C7.42908 17.0739 7.04956 16.6993 7.04956 16.2367C7.04956 15.7741 7.42908 15.3994 7.89766 15.3994H12.7438C13.2124 15.3994 13.5919 15.7741 13.5919 16.2367C13.5919 16.6993 13.2124 17.0739 12.7438 17.0739Z"
        fill="currentColor"
      />
      <path
        d="M26.6952 12.9764C26.5567 12.9764 26.416 12.9429 26.286 12.8725L20.8992 9.93928C20.4892 9.71601 20.3401 9.20668 20.5663 8.802C20.7924 8.39733 21.3084 8.25011 21.7183 8.47338L27.1051 11.4066C27.515 11.6298 27.6642 12.1392 27.438 12.5438C27.2832 12.8208 26.9935 12.9771 26.6945 12.9771L26.6952 12.9764Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ThreadsRev;
